import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const SHARE = {
  daily: ["s", "Today's {s} horoscope from Astra"],
  weekly: ["w", "{s}'s week ahead, from Astra"],
  monthly: ["m", "{s}'s month ahead, from Astra"],
};

export default function ShareSignButton({ sign, kind = "daily" }) {
  const { user } = useAuth();
  const from = user?.trinity?.sun?.sign;
  const share = async () => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/share/${SHARE[kind][0]}/${sign.toLowerCase()}${from ? `?from=${from.toLowerCase()}` : ""}`;
    const text = SHARE[kind][1].replace("{s}", sign);
    try {
      if (navigator.share) {
        await navigator.share({ title: text, text, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      toast.success("Link copied, send it to a friend");
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Couldn't share right now");
    }
  };
  return (
    <button
      data-testid="btn-share-sign"
      onClick={share}
      className="flex items-center gap-1.5 text-sm text-[#04060B] bg-[#D4AF37] hover:bg-[#e6c04e] px-4 py-1.5 rounded-full transition-colors"
    >
      <Share2 size={14} /> Share
    </button>
  );
}
